module.exports = __webpack_public_path__ + "static/media/protective-trousers.c25f6edb.jpg";